/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.reports.mappings.controllers', [
  'acme.common.service.api',
  'acme.common.factory.notice'
])

.controller('ReportsMappingsController', ['$scope', '$timeout', 'DataSources', 'ApiService', 'NoticeFactory', function($scope, $timeout, DataSources, ApiService, NoticeFactory) {

    $scope.reportsMappings = {

      model: [],
      fields: [],
      selected: '',

      search: '',
      searchQuery: '',
      grid: {
        pageSize: 50,
        showFooter: true,
        paginate: true,
        multiselect: false,
        columns:  [
          {
            field: 'internalName',
            displayName: 'Field Name',
            cellClass: 'inactive',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'displayName',
            displayName: 'Display Name',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            enableCellEdit: true
          }
        ]
      },
      isLoaded: true,

      notice: new NoticeFactory(),

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Field Aliases',
          buttonLeft: {
            label: 'Cancel',
            action: function () {
              $scope.reportsMappings.cancel();
            }
          },
          buttonRight: {
            label: 'Update',
            permissions: ['REPORT_FIELDS_UPDATE'],
            action: function () {
              $scope.reportsMappings.update();
            }
          }
        });

        if (DataSources && DataSources.data.success) {
          this.success.init(DataSources);
        }else{
          this.error.init(DataSources);
        }
      },

      cancel: function() {
        window.history.go(-1);
      },

      update: function() {
        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();
        ApiService.analytics.report.config.updateFields(this.model).then(this.success.update, this.error.update);
      },

      getFields: function() {
        this.isLoaded = false;
        ApiService.analytics.report.config.getFields(this.selected).then(this.success.getFields, this.error.getFields);
      },

      isSelected: function(name) {
        return (this.selected === name);
      },

      selectDatasource: function(name) {
        this.selected = name;
        this.getFields();
      },

      hasData: function() {
        return (this.fields instanceof Array && this.fields.length > 0);
      },

      success: {
        init: function(response) {
          var self = $scope.reportsMappings;
          self.sources = response.data.payload;
        },
        update: function(response) {
          var self = $scope.reportsMappings;
          self.notice.showSuccessMessages([{
            message: 'Successfully updated mappings'
          }]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        },
        getFields: function(response) {
          var self = $scope.reportsMappings;
          self.model = response.data.payload;
          self.fields = self.model.fieldNames;
          self.isLoaded = true;
        }
      },

      error: {
        init: function(response) {},
        update: function(response) {
          var self = $scope.reportsMappings;
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        getFields: function(response) {}
      },

      gridDoubleClick: function() {}

    };

    $scope.reportsMappings.init();

}]);